export default "__VITE_ASSET__BYioWwk___"